import { render, staticRenderFns } from "./memberScreening.vue?vue&type=template&id=ba2fcc8a&scoped=true&"
import script from "./memberScreening.vue?vue&type=script&lang=js&"
export * from "./memberScreening.vue?vue&type=script&lang=js&"
import style0 from "./memberScreening.vue?vue&type=style&index=0&id=ba2fcc8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba2fcc8a",
  null
  
)

export default component.exports